import { Box, Flex, Text } from '@chakra-ui/react';

export interface FormatProperties {
  handleTextDecoration: (style: string) => void;
  selectedStyle: string;
}

const RowFormatting = ({ handleTextDecoration, selectedStyle }: FormatProperties) => {
  const handleChange = (style: string) => {
    if (selectedStyle === style) {
      handleTextDecoration('');
    } else {
      handleTextDecoration(style);
    }
  };
  const BUTTON_STYLE = {
    width: '29px',
    height: '29px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    cursor: 'pointer',
    fontFamily: 'Roboto Regular',
    fontSize: '13px',
  };
  return (
    <Flex justifyContent={'space-between'} alignItems='center'>
      <Text fontFamily='Roboto Regular' fontWeight='500' fontSize='13px' color='#121826'>
        Cell formating
      </Text>
      <Flex gap='4px'>
        <Box
          {...BUTTON_STYLE}
          fontWeight='700'
          bg={selectedStyle === 'bold' ? '#8B5CF6' : '#F5F0FF'}
          color={selectedStyle === 'bold' ? 'white' : '#121826'}
          onClick={() => handleChange('bold')}
        >
          B
        </Box>
        <Box
          {...BUTTON_STYLE}
          fontStyle='italic'
          bg={selectedStyle === 'italic' ? '#8B5CF6' : '#F5F0FF'}
          color={selectedStyle === 'italic' ? 'white' : '#121826'}
          onClick={() => handleChange('italic')}
        >
          I
        </Box>
        <Box
          {...BUTTON_STYLE}
          textDecoration='underline'
          bg={selectedStyle === 'underline' ? '#8B5CF6' : '#F5F0FF'}
          color={selectedStyle === 'underline' ? 'white' : '#121826'}
          onClick={() => handleChange('underline')}
        >
          U
        </Box>
      </Flex>
    </Flex>
  );
};
export default RowFormatting;
